import { getQuantity, setFormLoading, addItemsToCart, addItemsAndRedirect, getFormProperties } from 'cart-add-helpers';

function isMobileScreen() {
	return window.matchMedia('(max-width: 768px)').matches;
}

function getGiftItems(productInfo) {
	const giftProductsRoot = productInfo?.querySelector('gift-products');
	if (typeof giftProductsRoot?.buildGiftItems !== 'function') return [];
	return giftProductsRoot.buildGiftItems();
}

// mirrors the direct_checkout select setting's option values in sections/main-product.liquid
const DIRECT_CHECKOUT_MODES = {
	NONE: 'none',
	MOBILE: 'mobile',
	DESKTOP: 'desktop',
	BOTH: 'both',
};

function shouldDirectCheckout(form) {
	const mode = form.querySelector('[data-direct-checkout]')?.dataset.directCheckout || DIRECT_CHECKOUT_MODES.NONE;
	if (mode === DIRECT_CHECKOUT_MODES.BOTH) return true;
	if (mode === DIRECT_CHECKOUT_MODES.MOBILE) return isMobileScreen();
	if (mode === DIRECT_CHECKOUT_MODES.DESKTOP) return !isMobileScreen();
	return false;
}

function getDigitalBundle(productInfo, activeVariantId, quantity) {
	const digitalProductsRoot = productInfo?.querySelector(`digital-products[data-parent="${activeVariantId}"]`);
	if (typeof digitalProductsRoot?.buildDigitalItems !== 'function') {
		return { items: [], mainItemProperties: {} };
	}
	return digitalProductsRoot.buildDigitalItems(quantity);
}

// coordinates all cart contributions: gift items, direct-checkout and digital-bundle contributions on cart submit
document.addEventListener(
	'submit',
	async (event) => {
		const form = event.target;
		if (!form.matches('form[action*="/cart/add"]')) return;

		const productInfo = form.closest('.product-info');
		const variantInput = form.querySelector('[name="id"]');
		const activeVariantId = parseInt(variantInput?.value, 10);
		if (isNaN(activeVariantId)) return;

		const quantity = getQuantity(form);

		const giftItems = getGiftItems(productInfo);
		const directCheckout = shouldDirectCheckout(form);
		const digitalBundle = getDigitalBundle(productInfo, activeVariantId, quantity);

		const hasContribution = giftItems.length > 0 || directCheckout || digitalBundle.items.length > 0;

		// nothing to do, form can submit natively
		if (!hasContribution) return;

		event.preventDefault();
		event.stopImmediatePropagation();

		const mainItem = {
			id: activeVariantId,
			quantity,
			properties: { ...getFormProperties(form), ...digitalBundle.mainItemProperties },
		};

		const items = [mainItem, ...giftItems, ...digitalBundle.items];

		setFormLoading(form, true);

		try {
			if (directCheckout) {
				await addItemsAndRedirect(items);
			} else {
				await addItemsToCart(items);
			}
		} catch (err) {
			form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: err.message } }));
			document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: err.message, tone: 'error' } }));
			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
		} finally {
			setFormLoading(form, false);
		}
	},
	true,
);
